import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@vds/buttons';

const SessionModalFooter = ({ buttonText, sessionTimedOut, onLogoff, sessionKeepAlive }) => (
  <div style={{ position: 'absolute', bottom: '0%', width: '100%', paddingRight: '16px', paddingBottom: '16px' }}>
    <Button
      use="primary"
      role="button"
      width="100%"
      data-analyticstrack="Session_Continue"
      onClick={(e) => (sessionTimedOut === false ? sessionKeepAlive() : onLogoff(e))}
    >
      {buttonText}
    </Button>
  </div>
);

SessionModalFooter.propTypes = {
  buttonText: PropTypes.string,
  sessionTimedOut: PropTypes.bool,
  onLogoff: PropTypes.func,
  sessionKeepAlive: PropTypes.func,
};

export default SessionModalFooter;
